import { EyeOff } from 'lucide-react'
import { PERMISSIONS } from '@/lib/permissions'
import { GroupActionList } from './GroupActionList'
import { GROUP_OPS_STR as S, setGroupHidden } from './groupOpsApi'

/**
 * A4.26 — Kanalni yashirish (qidiruvdan). Kanalni global qidiruvdan olib
 * tashlaydi. JONLI `/admin/groups` ro'yxati; mutatsiya endpoint chiqqach jonli.
 */
export function GroupHideFromSearch() {
  return (
    <GroupActionList
      screenId="A4.26"
      title={S.hideFromSearch}
      description={S.hideNote}
      actionId="hide"
      actionLabel={S.hideFromSearch}
      actionIcon={<EyeOff size={13} />}
      emptyIcon={<EyeOff size={28} strokeWidth={1.5} />}
      permission={PERMISSIONS.USERS_BAN}
      successMsg={S.hidden}
      run={async (r) => {
        if (!window.confirm(S.hideConfirm)) return false
        await setGroupHidden(r.id, true)
        return true
      }}
    />
  )
}
